import React from 'react';
export const DownloadXmlValuesButton = function EmptyComponent() { return null; };
